import { useState } from "react";
import { AlertDialog, AlertDialogAction, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export function TermsGate() {
  const { user } = useAuth();
  const [agreed, setAgreed] = useState(false);
  const [busy, setBusy] = useState(false);
  const [accepted, setAccepted] = useState(false);
  const need = !accepted && user && user.role === "owner" && !user.impersonating && user.terms_version_current && user.terms_version_accepted !== user.terms_version_current;
  if (!need) return null;
  const accept = async () => {
    if (!agreed) { return; }
    setBusy(true);
    try { await api.post("/auth/accept-terms", { version: user.terms_version_current }); setAccepted(true); toast.success("Obrigado!"); }
    catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  };
  return (
    <AlertDialog open={true}>
      <AlertDialogContent data-testid="terms-gate" className="bg-zinc-950 border border-zinc-800 text-zinc-100 max-w-md">
        <AlertDialogHeader>
          <AlertDialogTitle className="font-display uppercase">Atualização dos Termos</AlertDialogTitle>
          <AlertDialogDescription className="text-zinc-400">
            {user.terms_version_accepted ? "Atualizamos nossos termos e precisamos do seu aceite para continuar." : "Para começar a usar o AutoOficina, confirme que leu e aceita os documentos abaixo."}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <label className="flex items-start gap-2 text-sm text-zinc-200">
          <input data-testid="terms-check" type="checkbox" checked={agreed} onChange={(e) => setAgreed(e.target.checked)} className="mt-1" />
          <span>Li e aceito os <a href="/termos" target="_blank" rel="noopener noreferrer" className="text-green-neon underline">Termos de Uso</a> e a <a href="/privacidade" target="_blank" rel="noopener noreferrer" className="text-green-neon underline">Política de Privacidade</a> (versão {user.terms_version_current}).</span>
        </label>
        <AlertDialogFooter>
          <AlertDialogAction data-testid="terms-accept" disabled={!agreed || busy} onClick={accept} className="bg-green-brand hover:bg-green-brandDark text-white">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Aceitar e continuar"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
